import { preBootstrapForEMailContext } from './utils/preBootstrapForEMailContext';
import { setCdnContainer } from 'owa-config/lib/defaultCdnSettings';
import { setLayout, setOpxHostApp } from 'owa-config';

setCdnContainer('owamini/');
setLayout('Phone');
preBootstrapForEMailContext();
setOpxHostApp('outlookedge');
